import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Vue.component("article-items-treeview-select", {
    components: { Treeselect },
    props: [
        "article",
        "value",
        "language",
        "guid",
        "placeholder",
        "isReadOnly",
        "type",
        "flat",
        "addany",
        "expanded",
        "containerClass",
        "samevaluedisplay",
        "autoDeselectAncestors",
        "autoSelectDescendants",
        "autoDeselectDescendants",
        "refVal"
    ],
    data() {
        return {
            loading: false,
            loadingText: window.labels.loading,
            myValue: this.value,
            articleItems: [],
            searchWrapperInjected: false,
            articleId: this.article,
            flatType: this.flat,
            valueCombining: this.type,
            expandedType: this.expanded,
            height: 300,
            append: true,
            autoDeselectParents: this.autoDeselectAncestors,
            autoSelectChildrens: this.autoSelectDescendants,
            autoDeselectChildrens: this.autoDeselectDescendants,
            refValue: this.refVal
        }
    },
    mounted() {
        
        if (this.flatType == null) {
            this.flatType = true;
        }
        if (this.autoDeselectParents == null) {
            this.autoDeselectParents = false;
        }
        if (this.autoSelectChildrens == null) {
            this.autoSelectChildrens = false;
        }
    },
    watch: {
        myValue: function (value) {
            if (value != this.value) {
                this.$emit('update:value', value);
            }
        },
        article: {
            immediate: true,
            handler(value) {
                this.refreshItems(value);
            }
        },
        value: function (val) {
            if (val != this.myValue) {
                this.myValue = val;
            }
        }
    },
    methods: {
        refreshItems: function (articleId) {
            this.loading = true;
            this.searchWrapperInjected = false;
            if (this.samevaluedisplay == true) {
                this.$services.articleItems.getTreeviewSelectItemsString({
                    articleId: articleId,
                    language: this.language,
                    addAnySelector: this.addany
                })
                    .then((data) => {
                        this.loading = false;
                        this.articleItems = data;
                    });
            } else {
                this.$services.articleItems.getTreeviewSelectItems({
                    articleId: articleId,
                    language: this.language,
                    addAnySelector: this.addany
                })
                    .then((data) => {
                        this.loading = false;
                        this.articleItems = data;
                    });
            }
           
        },
        injectSearchWrapper: function () {
            if (!this.searchWrapperInjected) {
                this.searchWrapperInjected = true;
                let initialHandleLocalSearch = this.$refs.treeselect.handleLocalSearch;
                this.$refs.treeselect.handleLocalSearch = function () {
                    const minLength = 3;
                    let searchQuery = this.trigger.searchQuery;
                    this.rootOptionsStates.loadingError = "";

                    if (searchQuery.length && searchQuery.length < minLength) {
                        this.rootOptionsStates.loadingError = (
                            htmlEntity.decode(window.labels.treeSelectMinlengthError.replace("##error##", minLength))
                        );
                    } else {
                        initialHandleLocalSearch.call(this);
                    }
                };
            }
        },
        normalizer(node) {
            return {
                children: node.children && node.children.length ? node.children : 0
            }
        },
        onMenuOpen: function () {
            this.injectSearchWrapper();
        },
        deselect: function (node, instanceId) {


            if (node.id == 0) {

              
                this.myValue = [];
             
                this.$emit('update:value', []);
                this.$parent.$emit('update:value', []);
                this.$parent.$emit('updatetreeselectvalue', this.refValue);
                this.$refs.treeselect.clear();
            }
         
            console.log(this.myValue);
            console.log(this.value);

        }
    },
    template: `

        <div :id="guid" :class="containerClass">
	  		        <template v-if="loading"><loading></loading></template>
			        <template v-else>
                      <treeselect
                          @deselect="deselect"
                          v-model.sync="myValue"
                          :disabled="isReadOnly"
                          :class="{ 'is-readonly' : isReadOnly }"
                          ref="treeselect"
                          @open="onMenuOpen"
                          :multiple="true"
                          :flat="true"
                          :options="articleItems"
                          :disable-fuzzy-matching="true"
                          :loading-text="loadingText"
                          :normalizer="normalizer"
                          :placeholder="placeholder"
                          :max-height="height"
                          :value-consists-of="valueCombining"
                          :append-to-body="append"
                          :autoDeselectAncestors="autoDeselectParents"
                          :autoSelectDescendants="autoSelectChildrens"
                          :autoDeselectDescendants="autoDeselectChildrens"
                          :defaultExpandLevel="expandedType"
                          :clearable="true"
                          :clear-on-select="true"
                      />
                </template>
        </div>

    `
});